import React, {useState, useEffect } from 'react';
import { Button, Form, Input, Modal, Select } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import * as Setting from '../utils/AuthUtils';
import { composeSelectOptions } from '../utils/ComponentUtils';
import { api } from '../AppConfig';
import { useTranslation } from 'react-i18next';

function AddLeague(props) {
    const [form] = Form.useForm();
    const [isActive,setIsActive] = useState(false);
    const [users, setUsers] = useState([]);
    const [zones, setZones] = useState([]);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [error, setError] = useState([]);
    const [isLoaded, setIsLoaded] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        fetch(api.users().list().href, {
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            credentials: 'same-origin', // include, *same-origin, omit
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + Setting.getToken(),
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          })
        .then(res => res.json())
        .then(
          (result) => {
            setIsLoaded(true);
            setUsers(result.payLoad);
          },
          (error) => {
            setIsLoaded(true);
            setError(error); 
          }
        )
      fetch(api.leagues().lpiZones().href)
        .then(res => res.json())
        .then(
          (result) => {
            setIsLoaded(true);
            setZones(result.payLoad);
          },
          (error) => {
            setIsLoaded(true);
            setError(error);
          }
      )
    }, [])

    function togglePopover() {
        if (isActive) {
            setIsActive(false);
        } else {
            setIsActive(true);
        }
    }

    function handleCancel() {
      setIsActive(false);
      form.resetFields();
    }

    async function onFinish(values) {
        // values.stageId = props.seasonId
        // console.warn('values della form: ', values);
        setConfirmLoading(true);
        const response = await fetch(api.leagues().create().href, {
          method: 'POST', // *GET, POST, PUT, DELETE, etc.
          mode: 'cors', // no-cors, *cors, same-origin
          cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
          credentials: 'same-origin', // include, *same-origin, omit
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + Setting.getToken(),
            // 'Content-Type': 'application/x-www-form-urlencoded',
          },
          redirect: 'follow', // manual, *follow, error
          referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(values) // body data type must match "Content-Type" header
        })
        .then((data) => data.json())
        // .then((data) => window.location.reload(false))
        .catch((error) => console.error(error))

        // window.location.reload(false);
    }

    return(
            <div>
            <Modal title={t('leagues.create')} open={isActive} onClose={togglePopover} onOk={form.submit} onCancel={handleCancel} confirmLoading={confirmLoading} maskClosable={false}>
                <Form form={form} onFinish={onFinish}>
                    <Form.Item label={t('leagues.labelName')} name="leagueName">
                        <Input placeholder={t('leagues.labelName')} />
                    </Form.Item>
                    <Form.Item label={t('leagues.referral')} name="casdoorId">
                        <Select placeholder={t('leagues.selectReferral')}>
                            {composeSelectOptions(users,{ key: 'id', value: 'id', desc: 'displayName' })}
                        </Select>
                    </Form.Item>
                    <Form.Item label={t('leagues.lpiZone')} name="lpiZoneId">
                        <Select placeholder={t('leagues.selectZone')}>
                            {composeSelectOptions(zones,{ key: 'id', value: 'id', desc: 'zoneName' })}
                        </Select>
                    </Form.Item>
                </Form>
            </Modal>
            <Button style={{ marginTop: 16 }} type="primary" icon={<PlusOutlined />} onClick={togglePopover} >
              {t('leagues.create')}
            </Button>
            </div>
    )
}

export default AddLeague;